<template>
  <transition-group name="routing-fade" tag="div">
    <div class="bb-contact-documents" v-if="!openHandoversList" key="documents">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"></loader-fly>
      </transition>
      <div class="bb-contact-documents-header">
        <label class="bb-contact-documents-header-search">
          <input class="bb-contact-documents-header-search__input bb-input bb-input_search"
                 type="text"
                 @input="inputSearch"
                 placeholder="Search">
          <i class="icon-search bb-contact-documents-header-search__icon"/>
        </label>
        <div class="bb-contact-documents-header-menu" v-if="!companyId">
          <i class="icon-menu bb-contact-documents-header-menu__icon"
             :class="{'bb-contact-documents-header-menu__icon_disabled': selectedDocuments.length === 0}"
             @click.stop="popupNewHandover = !popupNewHandover"/>
          <transition name="bounce">
            <div class="bb-popup bb-contact-documents-header-menu-popup"
                 v-click-outside="hidePopupNewHandover"
                 v-if="popupNewHandover">
              <p class="bb-popup__item bb-contact-documents-header-menu-popup__text"
                 @click.stop="checkLocationDocs(docLocation.client)">
                Include all in Handover
              </p>
              <p class="bb-popup__item bb-contact-documents-header-menu-popup__text"
                 @click.stop="checkLocationDocs(docLocation.office)">
                Include all in Return
              </p>
            </div>
          </transition>
        </div>
        <button class="bb-button bb-contact-documents-header-button"
                @click="openHandoversList = true"
                v-if="!companyId">
          HANDOVERS
        </button>
      </div>
      <div class="bb-contact-documents__tags">
        <FilterByTags :tags="tags"
                      :filterTags="filterTags"
                      @setFilter="getClientDocuments"
                      companyFilterName="clientCompany"
                      ownFilterName="own"
                      tagFilterName="tag"/>
      </div>
      <VuePerfectScrollbar class="bb-contact-documents-body"
                           :class="{
                             'bb-contact-documents-body_alone': contactDocs.length === 1,
                             'bb-contact-documents-body_scrollX': hasScroll
                           }"
                           @ps-scroll-x="scrollXDocs"
                           @ps-scroll-y="scrollYDocs"
                           ref="bbContactDocsBody">
        <div class="bb-contact-documents-body__empty" v-if="!scrollXStart"/>
        <div>
          <div class="bb-contact-documents-body__empty-top"
               :class="{'bb-contact-documents-body__empty-top_hide': scrollYStart}"/>
          <div class="bb-contact-documents-body-doc"
               :class="{'bb-contact-documents-body-doc_view-mode': companyId}"
               v-for="(doc, index) in contactDocs"
               :key="doc.id"
               @mouseenter="setDocument(doc)"
               @mouseleave="setDocument(null)"
          >
            <div class="bb-contact-documents-body-doc-checkbox" v-if="!companyId">
              <CircleCheckbox @change="documentChecked" :item="doc" :value="getValueChecked(doc)"/>
            </div>
            <div class="bb-contact-documents-body-doc-controls">
              <i class="icon-donwload bb-icon bb-icon_accent"
                 @click="downloadFile(doc.uploadFile)"/>
            </div>
            <div class="bb-contact-documents-body-doc-info">
              <div class="bb-contact-documents-body-doc-info__label" @click="documentChecked(false, doc)">
                {{doc.label}}
              </div>
              <i class="icon-info bb-contact-documents-body-doc-info__comments"
                 :ref="'bbContactDocs' + doc.id"
                 v-if="doc.comment"
                 @mouseleave="showComments = false"
                 @mouseenter="setPositionPopup($event, doc.id)"/>
              <transition name="bounce">
                <Popup class="bb-contact-documents-body-doc-info-popup"
                       v-if="showComments === doc.id"
                       :style="popupPosition"
                       :radio="false"
                       :content="doc.comment"
                       />
              </transition>
              <transition name="bounce">
                <div class="bb-popup bb-popup__select-company
                          bb-contact-documents-body-doc-info-popup
                          bb-contact-documents-body-doc-info-popup_error"
                     :class="{
                  'bb-contact-documents-body-doc-info-popup_error_last': checkIndexDoc(index)
                }"
                     v-if="locationErrorTitle && locationError.includes(doc.id) && !checkHideError(doc, index)"
                     v-click-outside="closeErrorPopup">
                  <i class="icon-info"/>
                  <span class="bb-contact-documents-body-doc-info-popup__text">{{locationErrorTitle}}</span>
                  <i class="icon-cross bb-contact-documents-body-doc-info-popup__close"/>
                </div>
              </transition>
            </div>
            <div class="bb-contact-documents-body-doc-tags">
              <div class="bb-contact-documents-body-doc-tags__item"
                   v-if="doc.own && doc.own.name"
                   @click="setSearchTag(doc.own)">
                {{doc.own.name}}
              </div>
              <div class="bb-contact-documents-body-doc-tags__item"
                   v-if="doc.companyTag && doc.companyTag.name"
                   @click="setSearchTag(doc.companyTag)">
                #{{doc.companyTag.name}}
              </div>
              <div class="bb-contact-documents-body-doc-tags__item"
                   v-if="doc.tag && doc.tag.name"
                   @click="setSearchTag(doc.tag)">
                {{doc.tag.name}}
              </div>
            </div>
            <div class="bb-contact-documents-body-doc-location">
              <DocumentLocation :value="doc.locationDocument"/>
            </div>
            <div class="bb-contact-documents-body-doc-date">{{doc.formatDate}}</div>
            <button class="bb-button bb-contact-documents-body-doc__handover"
                    v-if="doc.currentHandover"
                    @click="downloadHandover(doc.currentHandover)">
              handover
            </button>
            <div
              v-if="hoverDocument.id === doc.id && !isOpenDoubleDelete"
              class="bb-contact-documents-body-doc-toolbar"
            >
              <transition name="bounce">
                <Toolbar
                         :index="hoverDocument.id"
                         :item="hoverDocument"
                         :noDeleteReasons="false"
                         :delete-index="deleteConfirmIndex"
                         @deleteItem="isOpenDoubleDelete = true"
                         @openEdit="setEditableRow"
                         @deleteOpen="deleteConfirmIndex = hoverDocument.id"
                         @deleteClose="!deleteConfirmIndex"
                />
              </transition>
            </div>
          </div>
        </div>
      </VuePerfectScrollbar>
      <div
        class="bb-contact-documents-upload" v-if="!companyId"
        @click.stop="openDocForm = true"
      >
        <div class="bb-contact-documents-upload__background" />
        <button class="bb-button-dashed bb-contact-documents-upload__button">
          <i class="icon-cross"/>
          Add new
        </button>
      </div>
      <Pagination :data="fullInfo" :getQuery="getClientDocuments" :limit="defLimit" class="bb-pagination"/>
      <DoubleDelete
        v-if="isOpenDoubleDelete"
        @close="isOpenDoubleDelete = false"
        @delete="onDeleteDocument"
      />
      <transition name="fade" mode="out-in">
        <div class="bb-contact-documents-form" v-if="openDocForm">
          <ContactDocumentsForm @close="closeDocForm"
                                :uploadError="fileUploadError"
                                :isDisableSend="loadingDownloadDocument"
                                :editDocument="hoverDocument"
                                @updateDocument="updateDocument"
          />
        </div>
      </transition>
      <transition name="fade" mode="out-in">
        <ModalWindow v-if="handoverModalOpen" @close="handoverClose" :without-padding="true">
          <ContactHandoverForm @close="handoverClose"
                               :type="handoverModalOpen"
                               :selectedDocuments="selectedDocuments"/>
        </ModalWindow>
      </transition>
    </div>
    <ContactHandoversList key="handovers" @close="openHandoversList = false" v-else/>
  </transition-group>
</template>

<script>
import moment from 'moment'
import {saveAs} from 'file-saver'
import {get, find, findIndex, debounce, trim, filter, cloneDeep} from 'lodash'
import ContactDocumentsForm
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactDocuments/ContactDocumentsForm/ContactDocumentsForm'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import UploadFileApi from '@/api/UploadFile/api'
import ContactDocsApi from '@/api/ContactDocs/api'
import setFileData from '@/mixin/setFileData'
import Pagination from '@/components/Main/Pagination/Pagination'
import {docsOwnTags, docsTags, docLocation} from '@/constants/documentTags'
import CircleCheckbox from '@/components/Main/Inputs/CircleCheckbox'
import DocumentLocation
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactDocuments/DocumentLocation/DocumentLocation'
import Popup from '@/components/Main/Popup/Popup'
import ContactHandoverForm
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactHandovers/ContactHandoverForm/ContactHandoverForm'
import {handoverType} from '@/constants/handover'
import ContactHandoversList
  from '@/components/Dissemination/Sales/CRM/ContactCard/ContactHandovers/ContactHandoversList/ContactHandoversList'
import FilterByTags from '@/components/Main/FilterByTags/FilterByTags'
import HandoverApi from '@/api/ContactHandover/api'
import ContactCompanyApi from '@/api/ContactCompanies/api'
import b64toBlob from 'b64-to-blob'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import Toolbar from "@/components/Main/Toolbar/Toolbar.vue";
import DoubleDelete from "@/components/Main/DoubleDelete/DoubleDelete.vue";

export default {
  name: 'ContactDocuments',
  components: {
    FilterByTags,
    ContactHandoversList,
    Popup,
    DocumentLocation,
    CircleCheckbox,
    VuePerfectScrollbar,
    ContactDocumentsForm,
    ModalWindow,
    Pagination,
    ContactHandoverForm,
    LoaderFly,
    Toolbar,
    DoubleDelete,
  },
  mixins: [setFileData],
  data () {
    return {
      filterTags: {
        tag: [],
        own: [],
        company: []
      },
      uniqueTags: [],
      uniqueCompanies: [],
      hasScroll: true,
      docLocation: docLocation,
      locationErrorTitle: '',
      handoverModalOpen: '',
      locationError: [],
      selectedDocuments: [],
      popupPosition: {position: 'absolute', left: 0, top: 0},
      showComments: false,
      scrollXStart: true,
      scrollYStart: true,
      fullInfo: {},
      defLimit: 25,
      file: {},
      fileUploadError: false,
      openDocForm: false,
      titleDocForm: 'Log in a document',
      popupNewHandover: false,
      openHandoversList: false,
      searchKeys: '',
      filterByOwn: '',
      filterByTag: '',
      filterByCompany: '',
      crypt: true,
      files: {},
      loaderRun: false,
      loadingDownloadDocument: false,
      hoverDocument: {},
      deleteConfirmIndex: '',
      isOpenDoubleDelete: false,
    }
  },
  computed: {
    companyId () {
      return this.$route.params.company
    },
    clientCompanies: {
      get () {
        return this.$store.getters.clientCompanies
      },
      set (data) {
        this.$store.dispatch('setClientCompanies', data)
      }
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    contactDocs: {
      get: function () {
        return this.$store.getters.contactDocs
      },
      set: function (data) {
        this.$store.dispatch('setContactDocs', data)
      }
    },
    tags () {
      const uniqueTagsWithCompanies = this.companyId ? this.uniqueTags : this.uniqueCompanies.concat(this.uniqueTags)
      const ownTags = this.companyId ? filter(docsOwnTags, {id: 2}) : docsOwnTags
      return this.uniqueTags.length > 0 ? ownTags.concat(uniqueTagsWithCompanies) : 0
    },
    getWithSearch () {
      return debounce(this.getClientDocuments, 250)
    }
  },
  methods: {
    setEditableRow () {
      this.openDocForm = true;
    },
    async onDeleteDocument() {
      try {
        this.loaderRun = true;
        await ContactDocsApi.deleteContactDoc(this.hoverDocument.id);
        await this.$store.dispatch('removeContactDoc', this.hoverDocument.id);
        this.hoverDocument = {};
        this.isOpenDoubleDelete = false;
      } catch (e) {
        console.log(e.message);
      }
      finally {
        this.loaderRun = false;
      }
    },
    setDocument(doc) {
      if (!doc) {
        this.hoverDocument = {};
        this.deleteConfirmIndex = '';
        return;
      }
      this.hoverDocument = doc;
    },
    inputSearch (e) {
      const val = e.target.value
      const searchValue = trim(val.toLowerCase())
      this.searchKeys = searchValue || ''
      this.getWithSearch({})
    },
    downloadHandover (handoverId) {
      this.loaderRun = true
      HandoverApi.getHandoverById(handoverId)
        .then((resp) => {
          const blob = b64toBlob(resp.data.uploadFile.base64, resp.data.uploadFile.type)
          saveAs(blob, resp.data.uploadFile.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    closeErrorPopup () {
      this.locationErrorTitle = ''
    },
    setSearchTag (tag) {
      const index = this.filterTags[tag.type].indexOf(tag.id)
      if (index !== -1) {
        this.filterTags[tag.type].splice(index, 1)
      } else {
        this.filterTags[tag.type].push(tag.id)
      }
    },
    checkIndexDoc (index) {
      const lastItem = index === this.contactDocs.length - 1
      return lastItem && this.contactDocs.length > 1
    },
    checkHideError (doc, index) {
      const penultimateIndex = this.contactDocs.length > 2 ? this.contactDocs.length - 2 : 0
      const penultimateDoc = this.contactDocs[penultimateIndex] || {}
      const penultimateError = this.locationError.includes(penultimateDoc.id)
      const lastIndex = this.contactDocs.length - 1
      const lastDocs = this.contactDocs[lastIndex] || {}
      const lastError = this.locationError.includes(lastDocs.id)
      return penultimateError && lastError && index === lastIndex && penultimateIndex !== lastIndex
    },
    setPositionPopup (e, docId) {
      this.showComments = docId
      const props = 'bbContactDocs' + docId
      const popups = get(this.$refs, props, '')
      const popupWidth = get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      this.popupPosition = {
        position: 'fixed',
        left: (box.left - diffLeft + 5) + 'px',
        top: box.top + 30 + 'px'
      }
    },
    documentChecked (value, item) {
      const index = findIndex(this.selectedDocuments, {id: item.id})
      if (index === -1) {
        this.selectedDocuments.push(item)
      } else {
        this.selectedDocuments.splice(index, 1)
      }
    },
    getValueChecked (doc) {
      const index = findIndex(this.selectedDocuments, {id: doc.id})
      return index > -1
    },
    scrollXDocs (e) {
      this.scrollXStart = e.target.scrollLeft <= 30
    },
    scrollYDocs (e) {
      this.scrollYStart = e.target.scrollTop <= 30
    },
    getFile (id) {
      this.loaderRun = true
      UploadFileApi.getFile(id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    downloadFile (file) {
      const newFile = typeof file === 'string' ? file : file.id
      this.files[newFile] ? saveAs(this.files[newFile].blob, this.files[newFile].label) : this.getFile(newFile)
    },
    handoverClose () {
      this.handoverModalOpen = false
      this.selectedDocuments = []
    },
    closeDocForm () {
      this.openDocForm = false;
    },
    hidePopupNewHandover () {
      this.popupNewHandover = false
    },
    openHandover (toType) {
      if (toType === 1) {
        this.handoverModalOpen = handoverType.received
      } else if (toType === 2) {
        this.handoverModalOpen = handoverType.returned
      }
      this.closeErrorPopup()
    },
    checkLocationDocs (toType) {
      const checkedDocs = this.selectedDocuments.length > 0
      const checkedLocation = this.selectedDocuments.every(doc => doc.locationDocument !== toType)
      if (checkedLocation && checkedDocs) {
        this.openHandover(toType)
      } else if (!checkedLocation) {
        this.setErrorLocation(toType)
      }
      this.hidePopupNewHandover()
    },
    setErrorLocation (toType) {
      const errorText = toType === 1 ? 'included. It is with client.' : 'returned. It is in the office.'
      this.locationErrorTitle = 'This item cannot be ' + errorText
      const failedDocs = this.selectedDocuments.filter(doc => doc.locationDocument === toType)
      this.locationError = failedDocs.map(item => item.id)
      setTimeout(this.closeErrorPopup, 5000)
    },
    getCompany (companyId) {
      if (!companyId) return {}
      const company = find(this.clientCompanies, {id: companyId}) || {}
      const result = {
        id: company.id || '',
        name: company.name || '',
        type: 'company'
      }
      return result.id ? result : {}
    },
    getInfoDocument(doc) {
      const { _id, label} = doc.uploadFile || {};
      doc.own = this.getTagName(doc.own, 'own');
      doc.tag = this.getTagName(doc.tag, 'tag');
      doc.companyTag = this.getCompany(doc.clientCompany);
      doc.uploadFile = _id;
      doc.uploadFileLabel = label;
      const atClient = doc.locationDocument === docLocation.client;
      doc.formatDate = doc.date && atClient ? moment(doc.date).format('DD-MMM-YY') : 'N/A';
      return doc;
    },
    setInfoDocs (docs) {
      return docs.map(item => this.getInfoDocument(item));
    },
    getClientDocuments ({page, own, tag, clientCompany}) {
      if (this.companyId === 'new') {
        this.contactDocs = []
        this.fullInfo = {}
        return
      }
      this.filterByOwn = own || this.filterByOwn
      this.filterByTag = tag || this.filterByTag
      this.filterByCompany = clientCompany || this.filterByCompany
      const clientCompanyFilter = 'clientCompany[]=' + this.companyId
      ContactDocsApi.getContactDocs({
        page,
        tagFilter: !!this.companyId,
        limit: this.defLimit,
        clientCompany: this.companyId ? clientCompanyFilter : this.filterByCompany,
        own: this.filterByOwn,
        tag: this.filterByTag,
        search: this.searchKeys,
        client: this.clientInfo.id
      })
        .then((resp) => {
          this.scrollUp()
          this.fullInfo = resp.data
          this.contactDocs = this.setInfoDocs(resp.data.clientdocuments)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setUniques (resp) {
      const respUniqueCompanies = resp.data.uniqueCompanies || []
      const companies = respUniqueCompanies.map(id => find(this.clientCompanies, {id: id}) || {})
      this.uniqueCompanies = companies.map(company => {
        return {
          id: company.id,
          name: '#' + company.name,
          type: 'company'
        }
      })
      const respUniqueTags = resp.data.uniqueTags || []
      this.uniqueTags = respUniqueTags.map(tag => find(docsTags, {id: tag}) || {})
    },
    getUniqueTags () {
      if (this.companyId === 'new') {
        this.uniqueTags = []
        return
      }
      ContactDocsApi.getContactDocs({limit: 1, client: this.clientInfo.id, clientCompany: this.companyId})
        .then((resp) => {
          this.setUniques(resp)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    scrollUp () {
      const scroll = get(this.$parent, '$el', '')
      if (!scroll) return
      scroll.scrollTop = 0
    },
    getTagName (id, type) {
      const types = {
        own: docsOwnTags,
        tag: docsTags
      }
      return find(types[type], {id: id}) || {}
    },
    checkScroll () {
      const scroll = get(this.$refs, 'bbContactDocsBody.$el', '')
      if (!scroll) return
      this.hasScroll = scroll.clientWidth < scroll.scrollWidth
    },
    getCompanies ({limit = 100, page = 1}) {
      if (this.companyId === 'new') {
        return
      }
      ContactCompanyApi.getContactCompanies({limit, page, client: this.clientInfo.id})
        .then((resp) => {
          this.clientCompanies = resp.data.clientcompanies
        })
        .catch((e) => {
          console.error(e)
        })
    },
    updateDocument(document) {
      const doc = this.getInfoDocument(document);
      this.contactDocs = this.contactDocs.map((item) =>
        item.id === doc.id
          ? {...doc}
          : item
      );
    },
  },
  watch: {
    openHandoversList (newVal) {
      if (newVal) this.$emit('change')
      this.selectedDocuments = []
      this.getClientDocuments({})
    },
    contactDocs () {
      this.getUniqueTags()
    },
    $route () {
      this.openHandoversList = false
      this.selectedDocuments = []
      this.getClientDocuments({})
      this.getUniqueTags()
      this.checkScroll()
    }
  },
  mounted () {
    this.checkScroll()
  },
  beforeMount () {
    this.getCompanies({})
    window.addEventListener('resize', this.checkScroll, false)
    this.getClientDocuments({})
    this.getUniqueTags()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScroll, false)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-contact-documents {
    @include global-font;
    display: grid;

    &-header {
      position: sticky;
      top: 0;
      display: flex;
      align-items: center;
      z-index: 21;
      background-color: $color-white;
      padding: 0 25px;

      &-search {
        flex-grow: 1;
        position: relative;
        display: flex;
        align-items: center;
        background: $color-white;
        border: 1px solid $color-mercury;
        box-sizing: border-box;
        border-radius: 6px;

        &__input {
          width: 100%;
          height: 42px;
          padding-left: 40px;
        }

        &__icon {
          position: absolute;
          left: 13px;
          font-size: 15px;
          color: $color-silver;
        }
      }

      &-menu {
        position: relative;
        margin-left: 10px;

        &__icon {
          display: block;
          font-size: 20px;
          padding: 10px;
          transform: rotate(90deg);
          color: $color-accent;
          right: 41px;
          cursor: pointer;
          transition: 0.4s;

          &_disabled {
            pointer-events: none;
            color: $color-dusty-gray;
          }

          &:hover {
            color: $color-accent-hover;
          }
        }

        &-popup {
          box-shadow: 0 0 20px rgba($color-black, 0.08);
          padding: 6px 10px 0;
          width: auto;
          left: auto;
          right: 7px;
          white-space: nowrap;
          font-weight: 300;
          font-size: 13px;
          line-height: 16px;

          &__text {
            padding: 6px;
            margin-bottom: 6px;
            cursor: pointer;
            transition: 0.3s;

            &:hover {
              opacity: 0.7;
            }

            &:first-child {
              margin-top: 0;
            }
          }
        }
      }

      &-button {
        padding: 13px 14px;
        font-weight: 600;
        margin-left: 32px;
      }
    }

    &__tags {
      position: sticky;
      top: 44px;
      z-index: 20;
      background-color: $color-white;
      padding: 12px 25px 0;
    }

    &-body {
      display: grid;
      height: 100%;
      min-height: 50px;
      overflow: hidden;
      margin: 15px 0;

      &_alone {
        padding-bottom: 22px;
        margin-bottom: -15px;
      }

      &__empty {
        grid-row: 1/end;
        position: sticky;
        left: -15px;
        min-height: calc(100%);
        background-color: $color-white;
        min-width: 15px;
        z-index: 1;
      }

      &__empty-top {
        position: sticky;
        top: 0;
        height: 5px;
        width: 100%;
        background-color: $color-white;
        z-index: 3;

        &_hide {
          opacity: 0;
        }
      }

      &-doc {
        display: grid;
        grid-template-columns: 16px 58px 150px minmax(auto, 1fr) 32px minmax(110px, 0.5fr) 80px;
        grid-gap: 10px;
        align-items: center;
        justify-content: space-between;
        width: calc(100% - 50px);
        min-height: 52px;
        padding: 0 23px;
        background-color: $color-white;
        box-shadow: 0 0 20px rgba($color-black, 0.05);
        border-radius: 5px;
        font-size: 13px;
        line-height: 1;
        margin: 0 25px 7px;

        &_view-mode {
          grid-template-columns: 58px 150px minmax(auto, 1fr) 32px minmax(110px, 0.5fr) 80px;
        }

        &-info {
          position: relative;
          display: flex;
          align-items: center;

          &__label {
            padding: 14px 0;
            cursor: pointer;
            margin-right: 8px;
            font-weight: 500;
            transition: 0.3s;

            &:hover {
              opacity: 0.8;
            }
          }

          &__comments {
            font-size: 13px;
            color: $color-silver-chalice;
            cursor: pointer;
            line-height: 1;
            transition: 0.4s;

            &:hover {
              opacity: 0.8;
            }
          }

          &-popup {
            max-width: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: $color-white;
            background: rgba($color-black, 0.53);
            box-shadow: 0 0 12px rgba($color-black, 0.12);
            border-radius: 5px;
            font-weight: 500;
            padding-right: 10px;

            &__text {
              margin-left: 5px;
            }

            &__close {
              color: $color-silver-chalice;
              position: absolute;
              top: 4px;
              right: 4px;
              cursor: pointer;
            }

            &:before {
              left: 10px;
              border: 4px solid transparent;
              border-bottom: 5px solid rgba($color-black, 0.53);
              box-shadow: 0 0 12px rgba($color-black, 0.12);
            }

            &_error {
              flex-direction: row;
              top: 90%;
              left: 0;
              padding: 10px 25px 10px 10px;
              max-width: 350px;

              &_last {
                top: auto;
                bottom: 90%;

                &:before {
                  left: 10px;
                  top: auto;
                  bottom: -9px;
                  border: 4px solid transparent;
                  border-top: 5px solid rgba($color-black, 0.53);
                  box-shadow: 0 0 12px rgba($color-black, 0.12);
                }
              }
            }
          }
        }

        &-tags {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          padding-top: 10px;
          margin: 0 0 0 -20px;
          height: 100%;

          &__item {
            white-space: nowrap;
            color: $color-accent;
            display: inline-flex;
            justify-items: center;
            align-items: center;
            padding: 3px 5px;
            line-height: 16px;
            background: rgba($color-accent, 0.2);
            border-radius: 3px;
            margin: 0 0 10px 10px;
            cursor: pointer;
            transition: 0.3s;

            &:last-child {
              margin-right: 0;
            }

            &:hover {
              background: rgba($color-accent-hover, 0.2);
              color: $color-accent-hover;
            }
          }
        }

        &-location {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &-date {
          cursor: default;
          justify-self: center;
        }

        &-toolbar {
          width: 50px;
        }

        &-controls {
          display: grid;
          grid-template-columns: 25px 25px;
          align-items: center;
          grid-gap: 8px;
        }

        &__handover {
          white-space: nowrap;
          padding: 0 15px;
          width: 80px;
          height: 32px;
          text-transform: capitalize;
        }
      }
    }

    &-upload {
      width: calc(100% - 50px);
      height: 36px;
      position: sticky;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      justify-self: center;
      align-self: center;
      cursor: pointer;
      z-index: 10;
      transition: 0.3s;
      box-sizing: border-box;
      background-color: $color-white;

      &__background {
        position: absolute;
        top: -15px;
        left: -25px;
        height: calc(100% + 15px);
        width: calc(100% + 50px);
        background-color: $color-white;
      }

      &:hover &__button {
        color: $color-accent-hover;
        border-color: $color-accent-hover;
      }

      &__button {
        margin-top: 0;
        position: absolute;
        left: 0;
        top: 0;
      }

      &__input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding-top: 36px;
        opacity: 0;
        z-index: 1;
        cursor: pointer;
      }
    }

    &-form {
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background: rgba($color-black, 0.56);
      padding: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactDocuments/ContactDocuments.vue